// i18n
import { translateInComponent } from 'infras/i18n';
import translations from './i18n.json';

import styled from '@emotion/styled';
import { useRouter } from 'next/router';

import { spacing } from 'presentations/views/styles';
import Dialog from 'presentations/views/components/atoms/Dialog';
import Button from 'presentations/views/components/atoms/Button';

interface Props {
  onClose: any;
  text?: string | null;
}

export default function Component(props: Props) {
  const router = useRouter();
  const t = translateInComponent(translations);

  return (
    <Dialog isOpen onClose={props.onClose} title={t('title')} disableMinWidth>
      <Container>
        <Message>{props.text || t('message')}</Message>
        <Button color="primary" size="large" onClick={props.onClose}>
          {t('button')}
        </Button>
      </Container>
    </Dialog>
  );
}

const Container = styled.div`
  text-align: center;
`;
const Message = styled.div`
  margin-bottom: ${spacing(24)};
  white-space: pre-wrap;
  text-align: left;
`;
